export const orderBy = {
  MONTHLY_P_AND_I: 1,
  MONTHLY_ESCROW: 2,
  MONTHLY_ESCROW_SHORTAGE: 3,
  OPTIONAL_PROD: 4,
  MONTHLY_TOTAL: 5
};
//# sourceMappingURL=types.js.map